<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">
      {{ viewMode === ViewMode.Create ? "Create email notification profile" : viewMode === ViewMode.View ? "View email notification profile details" : "Edit email notification profile" }}
    </div>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close modal?"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    @if (successMessage) {
    <alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
      <coso-alert-message> {{ successMessage }} </coso-alert-message>
    </alert>
    } @if (errorMessage) {
    <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
      <coso-alert-message>
        <div class="d-inline" [innerHTML]="errorMessage"></div>
      </coso-alert-message>
    </alert>
    }

    <div class="card mb-3">
      <div class="card-header">General</div>
      <div class="card-body">
        <p class="text-muted">
          <small><em>All fields are required unless specified optional</em></small>
        </p>
        <coso-text-input [control]="formGroup.controls.name" [inputText]="formText.name" [readonly]="viewMode === ViewMode.View || entity?.isUsedInConfiguration"> </coso-text-input>
        <coso-text-input-chips
          type="email"
          [control]="formGroup.controls.email"
          [inputText]="formText.email"
          [formArray]="formGroup.controls.emails"
          [readonly]="viewMode === ViewMode.View"
        ></coso-text-input-chips>
        <coso-text-input [control]="formGroup.controls.fromEmailDisplayName" [inputText]="formText.fromEmailDisplayName" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        <coso-text-input type="email" [control]="formGroup.controls.fromEmail" [inputText]="formText.fromEmail" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">SMTP Server</div>
      <div class="card-body">
        <p class="text-muted">
          <small><em>All fields are required unless specified optional</em></small>
        </p>
        <coso-text-input [control]="formGroup.controls.server" [inputText]="formText.server" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        <coso-text-input type="number" [control]="formGroup.controls.port" [inputText]="formText.port" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        <coso-text-input [control]="formGroup.controls.username" [inputText]="formText.username" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        <coso-select-input [control]="formGroup.controls.smtpType" [inputText]="smtpTypeSelectBox" [readonly]="viewMode === ViewMode.View"></coso-select-input>
        @if (formGroup.controls.smtpType.value === SmtpType.MicrosoftAuthentication) {
        <div>
          <coso-text-input [control]="formGroup.controls.azureClientId" [inputText]="formText.azureClientId" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
          <coso-text-input [control]="formGroup.controls.azureTenantId" [inputText]="formText.azureTenantId" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
          <coso-text-input type="password" [control]="formGroup.controls.azureClientSecret" [inputText]="formText.azureClientSecret" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        </div>
        } @if (formGroup.controls.smtpType.value === SmtpType.GoogleAuthentication) {
        <div>
          <coso-text-input type="password" [control]="formGroup.controls.jsonKey" [inputText]="formText.jsonKey" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        </div>
        } @if (formGroup.controls.smtpType.value === SmtpType.BasicAuthentication) {
        <div>
          <coso-text-input type="password" [control]="formGroup.controls.password" [inputText]="formText.password" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        </div>
        } @if (formGroup.controls.smtpType.value === SmtpType.MicrosoftAuthentication || formGroup.controls.smtpType.value === SmtpType.GoogleAuthentication) {
        <div>
          <coso-text-input [control]="formGroup.controls.scopes" [inputText]="formText.scopes" [readonly]="viewMode === ViewMode.View"> </coso-text-input>
        </div>
        }

        <coso-toggle-input [control]="formGroup.controls.useSsl" [inputText]="formText.useSsl" [readonly]="viewMode === ViewMode.View"></coso-toggle-input>
      </div>
    </div>

    <div class="row">
      <div class="offset-lg-3 col-lg-7">
        <button type="button" class="btn btn-primary btn-block" (click)="sendTestEmail()"><i class="fa fa-envelope mr-1"></i> Send Test Email</button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-{{ viewMode !== ViewMode.View ? 'secondary' : 'primary' }}" (click)="activeModal.close()">{{ viewMode !== ViewMode.View ? "Cancel" : "Close" }}</button>
    @if (viewMode !== ViewMode.View) {
    <button type="submit" class="btn btn-primary">Save</button>
    }
  </div>
</form>
